export default __webpack_public_path__ + "static/media/activity-youtube-thumbnail.67640b32.png";